/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Save_Changes_LabelInputs */



/**
* | output |
* | --- |
* | "Save metadata changes" |
*
* @param {Event_Group_Metadata_Save_Changes_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_save_changes_label = /** @type {((inputs?: Event_Group_Metadata_Save_Changes_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Save_Changes_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer les modifications des métadonnées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadatenänderungen speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva le modifiche ai metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохраните изменения метаданных")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar cambios en los metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存元数据更改")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータの変更を保存する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा में किए गए बदलावों को सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar alterações de metadados")
	return /** @type {LocalizedString} */ ("Save metadata changes")
});